import { ICounterBoxProps, CounterBox } from "./components/CounterBox/CounterBox";
import { styles } from "./CounterBoxes.style";

export interface ICounterBoxesProps {
  items: ICounterBoxProps[];
}

export function CounterBoxes({ items }: ICounterBoxesProps) {
  return (
    <div className={styles.root()}>
      {items.map((item) => (
        <CounterBox
          key={`counter-box-${item.label}`}
          label={item.label}
          value={item.value}
          valueAdornment={item.valueAdornment}
          actionLink={item.actionLink}
          hint={item.hint}
          testSelector={item.testSelector}
        />
      ))}
    </div>
  );
}
